import { STATUS } from "@/constants/statuses";
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";
import { injectable } from "tsyringe";

import QuestionEntity from "../entities/QuestionEntity";

export interface QuestionsState extends EntityState<QuestionEntity, number> {
    paginationMeta: {
        perPage: number;
        totalCount: number;
        currentOffset: number;
    };
    status: STATUS;
}

export function createInitialState(): QuestionsState {
    return {
        paginationMeta: {
            perPage: 0,
            totalCount: 0,
            currentOffset: 0,
        },
        status: STATUS.VIRGIN,
    };
}

@injectable()
@StoreConfig({ name: "questions" })
class QuestionsStore extends EntityStore<QuestionsState> {
    constructor() {
        super(createInitialState());
    }

    getStatus(): STATUS {
        return this.getValue().status;
    }

    setStatus(status: STATUS) {
        this.update(() => ({
            status,
        }));
    }
}

export default QuestionsStore;
